import { Grid } from '@mantine/core';
import { useParams } from 'react-router';
import HeaderStatistic from '../HeaderStatistic';
import LazyLoadSpinner from '../LazyLoaderSpinner';

const EmailStats = ({ stats, period, email, currency }) => {
  const { accountId, domainId } = useParams();

  const segmentLink = (preset) => {
    return `#/accounts/${accountId}/domains/${domainId}/segments/new?preset=${preset}&id=${email.id}&startDate=${period.startDate}&endDate=${period.endDate}`;
  };

  let statsElement;
  if (!stats) {
    statsElement = (
      <Grid.Col span={12}>
        <Grid justify="center">
          <LazyLoadSpinner />
        </Grid>
      </Grid.Col>
    );
  } else {
    statsElement = (
      <Grid.Col span={12}>
        <Grid>
          <Grid.Col span="auto" ta="center" data-tour="emailSentStats">
            <HeaderStatistic
              title="Sent"
              link={segmentLink('emailSendForEmail')}
              stats={stats}
              stat="sent"
              id={email.id}
              statKey="count"
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center" data-tour="emailDeliveredStats">
            <HeaderStatistic
              title="Delivered"
              link={segmentLink('emailDeliveryForEmail')}
              stats={stats}
              percentageOfStat="sent"
              stat="deliveries"
              id={email.id}
              statKey="count"
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center" data-tour="emailOpenedStats">
            <HeaderStatistic
              title="Opened"
              link={segmentLink('emailOpenForEmail')}
              stats={stats}
              stat="opened"
              percentageOfStat="sent"
              id={email.id}
              statKey="count"
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center" data-tour="emailClicksStats">
            <HeaderStatistic
              title="Clicks"
              link={segmentLink('emailClickForEmail')}
              stats={stats}
              stat="clicks"
              percentageOfStat="opened"
              id={email.id}
              statKey="count"
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center" data-tour="emailPurchaseStats">
            <HeaderStatistic
              title="Purchases"
              link={segmentLink('emailPurchaseForEmail')}
              stats={stats}
              stat="purchases"
              percentageOfStat="clicks"
              id={email.id}
              statKey="count"
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center" data-tour="emailRevenueStats">
            <HeaderStatistic
              title="Revenue"
              stats={stats}
              stat="purchases"
              id={email.id}
              statKey="value"
              currency={currency}
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center" style={{ borderLeft: '1px dotted' }} data-tour="emailBouncesStats">
            <HeaderStatistic
              title="Bounces"
              link={segmentLink('emailBounceForEmail')}
              stats={stats}
              stat="bounces"
              id={email.id}
              statKey="count"
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center" data-tour="emailComplaintsStats">
            <HeaderStatistic
              title="Complaints"
              link={segmentLink('emailComplaintForEmail')}
              stats={stats}
              stat="complaints"
              id={email.id}
              statKey="count"
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center" data-tour="emailUnsubscribesStats">
            <HeaderStatistic title="Unsubscribes" stats={stats} stat="unsubscribes" id={email.id} statKey="count" />
          </Grid.Col>
        </Grid>
      </Grid.Col>
    );
  }
  return statsElement;
};

export default EmailStats;
